import {AlertIcon, CircleIcon, DotFillIcon} from '@primer/octicons-react'

import type {TriageState} from './utils/constants'

type IndicatorIconProps = {
  state: TriageState
  ariaLabel: string
  isError: boolean
  triageEnabled?: boolean
}

export function TriageAgentStatusIcon({state, ariaLabel, isError, triageEnabled}: IndicatorIconProps) {
  if (isError) {
    return <DotFillIcon size={12} aria-label={ariaLabel} />
  }

  switch (state) {
    case 'inactive':
      return <CircleIcon size={12} aria-label={ariaLabel} />
    case 'active':
      return <DotFillIcon size={16} aria-label={ariaLabel} />
    case 'warning':
      return triageEnabled ? (
        <AlertIcon size={16} aria-label={ariaLabel} />
      ) : (
        <CircleIcon size={12} aria-label={ariaLabel} />
      )
  }
}
